import { createFileRoute, Navigate } from '@tanstack/react-router';
import { zodSearchValidator } from '@tanstack/router-zod-adapter';

import { z } from 'zod';

import { useAuthContext, SignInForm } from '@web/auth';

// ----------------------------------------------------------------------

const searchSchema = z.object({
  returnTo: z.string().catch('/'),
});

export const Route = createFileRoute('/auth/sign-in')({
  component: Component,
  validateSearch: zodSearchValidator(searchSchema),
});

export default function Component() {
  const { returnTo } = Route.useSearch();

  const { user } = useAuthContext();

  const returnToClean =
    returnTo.at(-1) === '?' ? returnTo.slice(0, -1) : returnTo;

  if (user) return <Navigate to={returnToClean} />;

  if (user === null)
    return (
      <div className="h-screen items-center justify-center">
        <SignInForm />
      </div>
    );
}
